import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-top-slider',
  templateUrl: './top-slider.component.html',
  styleUrls: ['./top-slider.component.scss']
})
export class TopSliderComponent implements OnInit {

  swiperTop: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 4000,
    },
    loop: true,
    initialSlide: 0,
    effect: 'fade',
    // fadeEffect: {
    //   crossFade: true
    // },

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  public topSlides = [
    {
      'header': 'Somos especialistas en',
      'title': 'Emergencias Químicas',
      // 'subtitle': ' Contamos con una larga trayectoria',
      'img': 'assets/sliders/1.jpg'
    },
    {
      'header': 'Somos especialistas en',
      'title': 'Trabajos de alto riesgo',
      // 'subtitle': 'Otra desc breve del dev',
      'img': 'assets/sliders/2.jpg'
    },
    {
      'header': 'Somos especialistas en',
      'title': 'Asesoramiento y gestión del riesgo químico',
      // 'subtitle': 'Otra desc breve del dev',
      'img': 'assets/sliders/3.jpg'
    }

  ];

  constructor() { }

  ngOnInit() {
  }

}
